import * as Yup from 'yup';

export const validationSchema = Yup.object({
  name: Yup.string()
    .required('Namn är obligatoriskt')
    .min(3, 'Namnet måste vara minst 3 tecken'),
  selectedVehicles: Yup.array()
    .min(1, 'Du måste välja minst ett fordon'),
});
